import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import ChoiceChips from 'components/Form/choiceChips';
import FilterDrawerShell from 'components/Form/filterDrawerShell';
import FilterSection, { FilterField } from 'components/Form/filterSection';
import FilterSelect from "components/Form/filterSelect";
import { countActive, filterValueOf, resolveMultiValue } from 'components/Form/filterValues';
import { genderOptions } from 'utils/constants';

// Status is not here: the list filters it with the strip above the table.
const SECTION_KEYS = {
  employee: ["department", "gender"],
};

const ResignationFilterDrawer = ({
    handleFilterDrawer,
    showFilterDrawer,
    handleFilterChange,
    filters,
    handleApplyFilter,
    filterLoading,
    handleClearAll,
    isFilterDirty
}) => {
  const { department, departmentLoading } = useSelector((state) => state.common);
  const [departmentOption, setDepartmentOption] = useState([]);
  useEffect(() => {
    setDepartmentOption((department || []).map(item => ({ label: item.name, value: item.id })));
  }, [department]);

  const valueOf = (key) => filterValueOf(filters, key);

  return (
    <FilterDrawerShell
      open={showFilterDrawer}
      onClose={handleFilterDrawer}
      activeCount={countActive(filters, Object.values(SECTION_KEYS).flat())}
      onClearAll={handleClearAll}
      onApply={handleApplyFilter}
      applying={filterLoading}
      applyDisabled={!isFilterDirty}
    >
      <FilterSection title="Employee" count={countActive(filters, SECTION_KEYS.employee)}>
        <FilterField label="Department" hint="one or more" htmlFor="filter-resignation-department">
          <FilterSelect inputId="filter-resignation-department" isMulti={true} checkboxMenu={true} maxVisibleValues={2} menuPosition="fixed" isClearable={true} onChange={e=>{handleFilterChange(e, "department")}} optionLabel={"label"} optionValue={'value'} options={departmentOption} isLoading={departmentLoading} value={resolveMultiValue(valueOf("department"), departmentOption)} placeholder={"Any"} noOptionsLabel={"departments"}/>
        </FilterField>
        <FilterField label="Gender">
          <ChoiceChips ariaLabel="Gender" options={genderOptions} value={valueOf("gender")} onChange={(option) => handleFilterChange(option, "gender")} />
        </FilterField>
      </FilterSection>
    </FilterDrawerShell>
  );
};
export default ResignationFilterDrawer;
